import { connect } from 'react-redux';
import { compose } from 'redux';
import { has, find } from 'lodash';
import { activateSink, pauseSink, copySink, deleteSink, setPipelineAction } from '../../../actions';
import { ACTIVATE_SINK, PAUSE_SINK, COPY_SINK, DELETE_SINK } from '../../../constants/processTypes';
import DataSinkDetailActions from './DataSinkDetailActions';
import { withResourceEditProvider } from 'js/components/ResourceEditProvider/withResourceEditProvider';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';

const mapStateToProps = (state, ownProps) => {
  const {
    paging: { metaInfoById },
    entities: { flowNodes },
    processes: { all: processes },
  } = state;
  const {
    data: { id, origin_node_id },
    connectionOrVendorType,
  } = ownProps;
  const isPausing = !!find(processes, { type: PAUSE_SINK, id });
  const isActivating = !!find(processes, { type: ACTIVATE_SINK, id });
  const isCopying = !!find(processes, { type: COPY_SINK, id });
  const isDeleting = !!find(processes, { type: DELETE_SINK, id });
  const connectionCategory =
    metaInfoById && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType].connectionCategory
      : null;

  const flow = flowNodes[origin_node_id];

  return {
    flow,
    isPausing,
    isActivating,
    isCopying,
    isDeleting,
    connectionCategory,
  };
};

function DataSinkDetailActionsWithContext(props) {
  const { openDetailDrawerInPortal } = useResourceDetailHandler();
  return <DataSinkDetailActions {...props} openDetailDrawerInPortal={openDetailDrawerInPortal} />;
}

export default compose(
  connect(mapStateToProps, {
    activateSink,
    pauseSink,
    copySink,
    deleteSink,
    setPipelineAction,
  }),
  withResourceEditProvider,
)(DataSinkDetailActionsWithContext);
